import { useCallback, useState } from "react"
import { getAdditionalUserInfo, GoogleAuthProvider, signInWithPopup } from "firebase/auth"
import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore"
import { auth, db } from "@/config/firebase"
import { useSnackbar } from "@/shared/context/SnackbarContext"
import { trackSignupConversion } from "@/shared/services/googleAds"

const useGoogleAuth = () => {
  const { showSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)

  const signInWithGoogle = useCallback(async () => {
    const provider = new GoogleAuthProvider()
    setLoading(true)
    try {
      const creds = await signInWithPopup(auth, provider)
      const user = creds.user
      const isNewUser = getAdditionalUserInfo(creds)?.isNewUser === true
      const userRef = doc(db, "users", user.uid)
      const userSnap = await getDoc(userRef)
      if (!userSnap.exists()) {
        await setDoc(userRef, {
          email: user.email ?? "",
          displayName: user.displayName ?? "",
          createdAt: serverTimestamp()
        })
      } else {
        await setDoc(userRef, { email: user.email, displayName: user.displayName }, { merge: true })
      }
      if (isNewUser) trackSignupConversion("google")
    } catch (error) {
      showSnackbar("Google sign-in failed. Please try again.", "error")
    } finally {
      setLoading(false)
    }
  }, [showSnackbar])

  return { signInWithGoogle, loading }
}

export { useGoogleAuth }
